import { ScreenHeader } from "../../../components/structure/ScreenHeader";
import { ContentBox } from "../../../components/structure/ContentBox";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { FstyrDateRangePicker } from "../../../components/date-picker/DatePicker";
import { Button } from "../../../components/buttons/Button";
import { ReactComponent as Download } from "../../../../resources/icons/Download Bottom.svg";
import { useState } from "react";
import { useServiceContext } from "../../../../contexts/ServiceContext";
import { ReactComponent as Warning } from "../../../../resources/icons/warning_circle_red.svg";

export function StatisticDownloaderScreen() {
    const [date, setDate] = useState<{
        start: Date;
        end: Date;
    }>();
    const [latestError, setLatestError] = useState<string | null>(null);
    const {
        statisticsService: { getStatistic }
    } = useServiceContext();

    function handleDownloadCsv() {
        setLatestError(null);
        if (!date) {
            return;
        }
        const from = date.start;
        const to = date.end;
        getStatistic(from, to).then(
            (blob) => {
                setLatestError(null);

                // Create blob link to download
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `digital_læge_attest_statistik_${from.toLocaleDateString()}_${to.toLocaleDateString()}.csv`
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode?.removeChild(link);
            },
            () => {
                setLatestError("Ingen statistik fundet");
            }
        );
    }

    return (
        <>
            <div className={"w-[700px]"}>
                <ScreenHeader>
                    <span>Dine statistikker</span>
                    <p
                        className={
                            "mb-40 text-n font-normal text-secondary-gray-dark ml-[2px]"
                        }
                    >
                        Få en komplet oversigt over tilgængelige statistikker og
                        download dem for indenfor din valgte tidsramme.
                    </p>
                </ScreenHeader>
                <ContentBox className={"space-y-20"}>
                    <ContentHeader>Vælg din tidsperiode</ContentHeader>
                    <div>
                        <label
                            className="block tracking-wide text-secondary-gray-dark text-sx font-medium mb-2"
                            htmlFor="range-picker"
                        >
                            Periode
                        </label>
                        <FstyrDateRangePicker
                            id={"range-picker"}
                            onChange={setDate}
                            value={date}
                        />
                    </div>
                    {latestError && (
                        <div className="flex flex-row space-x-4 bg-status-error-light text-secondary-gray-dark rounded-2xl flex justify-centerr text-n p-20 border-status-error border">
                            <Warning
                                fill={"#FFE5E5"}
                                height={20}
                                width={20}
                                className={"scale-90"}
                            />
                            <span className="pr-4 font-semibold">
                                {latestError}
                            </span>
                        </div>
                    )}
                    <div className={"flex justify-end space-x-8 !mt-40"}>
                        <Button
                            theme={"tertiary"}
                            onClick={() => setDate(undefined)}
                        >
                            Nulstil
                        </Button>
                        <Button
                            disabled={!date}
                            icon={<Download />}
                            iconRight
                            onClick={handleDownloadCsv}
                        >
                            Download CSV
                        </Button>
                    </div>
                </ContentBox>
            </div>
        </>
    );
}
